import { render, staticRenderFns } from "./routeSet.vue?vue&type=template&id=5079bfdc&scoped=true&"
import script from "./routeSet.vue?vue&type=script&lang=js&"
export * from "./routeSet.vue?vue&type=script&lang=js&"
import style0 from "./routeSet.vue?vue&type=style&index=0&id=5079bfdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079bfdc",
  null
  
)

export default component.exports